import {Link} from "react-router-dom";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";
import {sitemap} from "../Sitemap";

const BreadCrumbs = () => {
    const breadcrumbs = useReactRouterBreadcrumbs(sitemap);

    return (
        <div>
            <ul className="breadcrumb inline-block mb-0 pull-right clear-float-on-mobile">
                {
                    breadcrumbs.map((breadcrumb, index, { length }) => (
                        <li key={index}>
                            {index !== length - 1 ? (
                                <Link to={breadcrumb.match.pathname}>{breadcrumb.breadcrumb}</Link>
                            ) : (
                                <>{breadcrumb.breadcrumb}</>
                            )}
                        </li>
                    ))
                }
            </ul>
        </div>
    )
}

export default BreadCrumbs;